import ICPContainer from './ICPContainer';
export default ICPContainer;
